// This will be the converted vanilla JS version
// (See the JavaScript artifact below)
// Belt Size Calculator - Vanilla JavaScript Version
class BeltCalculator {
  constructor() {
    this.isDark = false;
    this.unit = 'inches';
    this.waistMeasurement = '';
    this.result = null;
    this.showExplanation = false;
    this.showEmailForm = false;
    
    this.init();
  }

  init() {
    this.createHTML();
    this.bindEvents();
    this.updateTheme();
  }

  createHTML() {
    const container = document.getElementById('belt-calculator');
    if (!container) return;

    container.innerHTML = `
      <div class="calculator-wrapper">
        <!-- Header -->
        <div class="calculator-header">
          <div class="header-content">
            <div class="header-left">
              <div class="calculator-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                  <line x1="8" y1="21" x2="16" y2="21"/>
                  <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
              </div>
              <div class="header-text">
                <h1>Belt Size Finder</h1>
                <p>Professional Waist Fit Calculator</p>
              </div>
            </div>
            <button class="theme-toggle" id="themeToggle">
              <svg class="sun-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="5"/>
                <line x1="12" y1="1" x2="12" y2="3"/>
                <line x1="12" y1="21" x2="12" y2="23"/>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                <line x1="1" y1="12" x2="3" y2="12"/>
                <line x1="21" y1="12" x2="23" y2="12"/>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
              </svg>
              <svg class="moon-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
              </svg>
            </button>
          </div>
          <p class="header-description">
            Find your perfect belt size with our intelligent calculator. Enter your waist measurement 
            and get instant recommendations for both European and American sizing standards.
          </p>
        </div>

        <!-- Main Calculator Card -->
        <div class="calculator-card">
          <!-- Step 1: Unit Selection -->
          <div class="calculator-step">
            <h2 class="step-title">
              <span class="step-number">1</span>
              Choose Your Measurement Unit
            </h2>
            <div class="unit-buttons">
              <button class="unit-button active" data-unit="inches">
                <div class="unit-content">
                  <div class="unit-title">🇺🇸 Inches</div>
                  <div class="unit-subtitle">USA Standard Measurement</div>
                </div>
              </button>
              <button class="unit-button" data-unit="cm">
                <div class="unit-content">
                  <div class="unit-title">🇪🇺 Centimeters</div>
                  <div class="unit-subtitle">European Standard Measurement</div>
                </div>
              </button>
            </div>
          </div>

          <!-- Step 2: Input Measurement -->
          <div class="calculator-step">
            <h2 class="step-title">
              <span class="step-number">2</span>
              Enter Your Waist Measurement
            </h2>
            <div class="input-container">
              <div class="input-wrapper">
                <svg class="input-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L8.82 16.01a2 2 0 1 1-2.83-2.83l8.49-8.49"/>
                </svg>
                <input 
                  type="number" 
                  id="waistInput" 
                  placeholder="Enter waist size in inches"
                  step="0.1" 
                  min="0"
                />
                <span class="input-unit">inches</span>
              </div>
              <div class="input-help">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9,12l2,2 4,-4"/>
                </svg>
                Measure around your waist where you typically wear your belt, just above your hip bones.
              </div>
            </div>
          </div>

          <!-- Step 3: Results -->
          <div class="calculator-step" id="resultsStep" style="display: none;">
            <h2 class="step-title">
              <span class="step-number">✓</span>
              Your Belt Size Recommendation
            </h2>
            <div class="results-container">
              <div class="result-display">
                <div class="result-size" id="resultSize">36.0 inches</div>
                <div class="result-label" id="resultLabel">M (Medium)</div>
                <div class="result-conversion" id="resultConversion">≈ 91.4 cm</div>
              </div>
              <div class="result-explanation">
                <h4>How we calculated this:</h4>
                <p id="explanationText">
                  We added 6 inches to your waist measurement of 30.0 inches. 
                  This standard rule ensures your belt fits comfortably with room for adjustment and proper buckle positioning.
                </p>
              </div>
            </div>
          </div>

          <!-- Step 4: Save Results -->
          <div class="calculator-step" id="saveStep" style="display: none;">
            <h2 class="step-title">
              <span class="step-number">4</span>
              Save Your Results
            </h2>
            <div class="save-buttons">
              <button class="save-button primary" id="downloadBtn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7,10 12,15 17,10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
                Download Result
              </button>
              <button class="save-button secondary" id="emailBtn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                Email Result
              </button>
            </div>
            <div class="email-form" id="emailForm" style="display: none;">
              <div class="email-input-wrapper">
                <input type="email" id="emailInput" placeholder="Enter your email address" />
                <button class="email-send-btn" id="sendEmailBtn">Send</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Explanation Section -->
        <div class="explanation-card">
          <button class="explanation-toggle" id="explanationToggle">
            <div class="explanation-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9,12l2,2 4,-4"/>
              </svg>
              <div class="explanation-text">
                <h3>How Belt Sizing Works</h3>
                <p>Learn about the standard belt sizing formula and size charts</p>
              </div>
            </div>
            <svg class="chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6,9 12,15 18,9"/>
            </svg>
          </button>
          <div class="explanation-content" id="explanationContent" style="display: none;">
            <div class="explanation-section">
              <h4>The Standard Belt Sizing Rule</h4>
              <p>Belt sizes are calculated by adding a standard measurement to your waist size:</p>
              <ul>
                <li><strong>Imperial (Inches):</strong> Waist + 6 inches</li>
                <li><strong>Metric (Centimeters):</strong> Waist + 15 cm</li>
              </ul>
            </div>
            <div class="explanation-section">
              <h4>Belt Size Reference Chart</h4>
              <div class="size-chart">
                <table>
                  <thead>
                    <tr>
                      <th>Waist (in)</th>
                      <th>Belt Size (in)</th>
                      <th>Waist (cm)</th>
                      <th>Belt Size (cm)</th>
                      <th>Size Label</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>28"</td>
                      <td>34"</td>
                      <td>71 cm</td>
                      <td>86 cm</td>
                      <td>S (Small)</td>
                    </tr>
                    <tr>
                      <td>30"</td>
                      <td>36"</td>
                      <td>76 cm</td>
                      <td>91 cm</td>
                      <td>M (Medium)</td>
                    </tr>
                    <tr>
                      <td>32"</td>
                      <td>38"</td>
                      <td>81 cm</td>
                      <td>96 cm</td>
                      <td>L (Large)</td>
                    </tr>
                    <tr>
                      <td>34"</td>
                      <td>40"</td>
                      <td>86 cm</td>
                      <td>101 cm</td>
                      <td>XL (Extra Large)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  bindEvents() {
    // Theme toggle
    const themeToggle = document.getElementById('themeToggle');
    themeToggle?.addEventListener('click', () => this.toggleTheme());

    // Unit buttons
    document.querySelectorAll('.unit-button').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const unit = e.currentTarget.dataset.unit;
        this.setUnit(unit);
      });
    });

    // Waist input
    const waistInput = document.getElementById('waistInput');
    waistInput?.addEventListener('input', (e) => {
      this.handleInputChange(e.target.value);
    });

    // Download button
    const downloadBtn = document.getElementById('downloadBtn');
    downloadBtn?.addEventListener('click', () => this.downloadResult());

    // Email button
    const emailBtn = document.getElementById('emailBtn');
    emailBtn?.addEventListener('click', () => this.toggleEmailForm());

    // Send email button
    const sendEmailBtn = document.getElementById('sendEmailBtn');
    sendEmailBtn?.addEventListener('click', () => this.sendEmail());

    // Explanation toggle
    const explanationToggle = document.getElementById('explanationToggle');
    explanationToggle?.addEventListener('click', () => this.toggleExplanation());
  }

  calculateBeltSize(waist, unit) {
    const waistNum = parseFloat(waist);
    if (!waistNum || waistNum <= 0) return null;

    let beltSize, convertedSize, sizeLabel;
    
    if (unit === 'inches') {
      beltSize = waistNum + 6;
      convertedSize = beltSize * 2.54;
      
      if (beltSize <= 32) sizeLabel = 'XS (Extra Small)';
      else if (beltSize <= 34) sizeLabel = 'S (Small)';
      else if (beltSize <= 36) sizeLabel = 'M (Medium)';
      else if (beltSize <= 38) sizeLabel = 'L (Large)';
      else if (beltSize <= 40) sizeLabel = 'XL (Extra Large)';
      else if (beltSize <= 42) sizeLabel = 'XXL (2X Large)';
      else sizeLabel = 'XXXL (3X Large)';
    } else {
      beltSize = waistNum + 15;
      convertedSize = beltSize / 2.54;
      
      if (beltSize <= 80) sizeLabel = 'XS (Extra Small)';
      else if (beltSize <= 85) sizeLabel = 'S (Small)';
      else if (beltSize <= 90) sizeLabel = 'M (Medium)';
      else if (beltSize <= 95) sizeLabel = 'L (Large)';
      else if (beltSize <= 100) sizeLabel = 'XL (Extra Large)';
      else if (beltSize <= 105) sizeLabel = 'XXL (2X Large)';
      else sizeLabel = 'XXXL (3X Large)';
    }

    return {
      beltSize,
      convertedSize,
      sizeLabel,
      unit,
      waist: waistNum
    };
  }

  handleInputChange(value) {
    this.waistMeasurement = value;
    const result = this.calculateBeltSize(value, this.unit);
    
    if (result) {
      this.result = result;
      this.showResults();
    } else {
      this.hideResults();
    }
  }

  setUnit(unit) {
    this.unit = unit;
    
    // Update active button
    document.querySelectorAll('.unit-button').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.unit === unit);
    });

    // Update input placeholder and unit display
    const waistInput = document.getElementById('waistInput');
    const inputUnit = document.querySelector('.input-unit');
    
    if (waistInput && inputUnit) {
      waistInput.placeholder = `Enter waist size in ${unit}`;
      inputUnit.textContent = unit;
    }

    // Recalculate if we have a measurement
    if (this.waistMeasurement) {
      this.handleInputChange(this.waistMeasurement);
    }
  }

  showResults() {
    const resultsStep = document.getElementById('resultsStep');
    const saveStep = document.getElementById('saveStep');
    const resultSize = document.getElementById('resultSize');
    const resultLabel = document.getElementById('resultLabel');
    const resultConversion = document.getElementById('resultConversion');
    const explanationText = document.getElementById('explanationText');

    if (resultsStep && saveStep && this.result) {
      resultsStep.style.display = 'block';
      saveStep.style.display = 'block';

      resultSize.textContent = `${this.result.beltSize.toFixed(1)} ${this.result.unit}`;
      resultLabel.textContent = this.result.sizeLabel;
      resultConversion.textContent = this.result.unit === 'inches' 
        ? `≈ ${this.result.convertedSize.toFixed(1)} cm`
        : `≈ ${this.result.convertedSize.toFixed(1)} inches`;

      explanationText.textContent = `We added ${this.result.unit === 'inches' ? '6 inches' : '15 cm'} to your waist measurement of ${this.result.waist} ${this.result.unit}. This standard rule ensures your belt fits comfortably with room for adjustment and proper buckle positioning.`;
    }
  }

  hideResults() {
    const resultsStep = document.getElementById('resultsStep');
    const saveStep = document.getElementById('saveStep');
    
    if (resultsStep && saveStep) {
      resultsStep.style.display = 'none';
      saveStep.style.display = 'none';
    }
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    this.updateTheme();
  }

  updateTheme() {
    const wrapper = document.querySelector('.calculator-wrapper');
    if (wrapper) {
      wrapper.classList.toggle('dark-theme', this.isDark);
    }

    // Update theme toggle icon
    const themeToggle = document.getElementById('themeToggle');
    if (themeToggle) {
      const sunIcon = themeToggle.querySelector('.sun-icon');
      const moonIcon = themeToggle.querySelector('.moon-icon');
      
      if (this.isDark) {
        sunIcon.style.display = 'block';
        moonIcon.style.display = 'none';
      } else {
        sunIcon.style.display = 'none';
        moonIcon.style.display = 'block';
      }
    }
  }

  downloadResult() {
    if (!this.result) return;
    
    const content = `
Belt Size Calculator Result
==========================

Waist Measurement: ${this.result.waist} ${this.result.unit}
Recommended Belt Size: ${this.result.beltSize.toFixed(1)} ${this.result.unit}
Size Category: ${this.result.sizeLabel}
${this.result.unit === 'inches' ? 
  `Metric Equivalent: ${this.result.convertedSize.toFixed(1)} cm` : 
  `Imperial Equivalent: ${this.result.convertedSize.toFixed(1)} inches`}

Calculation Method:
We add ${this.result.unit === 'inches' ? '6 inches' : '15 cm'} to your waist measurement to determine the optimal belt length for comfortable wear.
    `;
    
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'belt-size-result.txt';
    a.click();
    URL.revokeObjectURL(url);
  }

  toggleEmailForm() {
    this.showEmailForm = !this.showEmailForm;
    const emailForm = document.getElementById('emailForm');
    if (emailForm) {
      emailForm.style.display = this.showEmailForm ? 'block' : 'none';
    }
  }

  sendEmail() {
    const emailInput = document.getElementById('emailInput');
    const email = emailInput?.value;
    
    if (!email || !this.result) return;
    
    alert(`Result sent to ${email}!\n\nRecommended belt size: ${this.result.beltSize.toFixed(1)} ${this.result.unit}\nSize: ${this.result.sizeLabel}`);
    
    emailInput.value = '';
    this.toggleEmailForm();
  }

  toggleExplanation() {
    this.showExplanation = !this.showExplanation;
    const content = document.getElementById('explanationContent');
    const chevron = document.querySelector('.explanation-toggle .chevron');
    
    if (content && chevron) {
      content.style.display = this.showExplanation ? 'block' : 'none';
      chevron.style.transform = this.showExplanation ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  }
}

// Initialize the calculator when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new BeltCalculator();
});